import React from "react";

export default function Register(){
    return(
        <p>
            register
        </p>
    )
}